import { all, takeEvery, put, fork, call, take } from 'redux-saga/effects';

import { REQUEST_ALERTS, REQUEST_ALERTS_MODIFY, WAIT_RECENT_ALERT, REQUEST_ALL_ALERTS_DONE } from '../constants/Alerts'
import { requestAlertsLoading, requestAlertsSuccess, requestAlertsFailed, requestAlertsModifySuccess, requestAlertsModifyFailed, addRecentAlert, requestAllAlertsDoneSuccess, requestAllAlertsDoneFailed } from '../actions/Alerts'
import { addAlertCount } from '../actions/Dashboard'
import TowncastService from '../../services/TowncastService'
import { createSignalRAlertChannel, closeChannel } from './createSignalRChannel';

export function* requestAlerts() {
    yield takeEvery(REQUEST_ALERTS, function* (action) {
        try {
            yield put(requestAlertsLoading(true))
            const response = yield call(TowncastService.getAlerts, action.siteid, action.start, action.end)
            yield put(requestAlertsSuccess(response.data))
        } catch (err) {
            yield put(requestAlertsFailed(err))
        }
    })
}

export function* requestAlertsModify() {
    yield takeEvery(REQUEST_ALERTS_MODIFY, function* (action) {
        try {
            const response = yield call(TowncastService.putAlert, action.alert)
            yield put(requestAlertsModifySuccess(response.data))
        } catch (err) {
            yield put(requestAlertsModifyFailed(err))
        }
    })
}

export function* waitRecentAlert() {
    yield takeEvery(WAIT_RECENT_ALERT, function* (action) {
        let channel
        try {
            channel = yield call(createSignalRAlertChannel, "addAlert", action.connection)

            while(true) {
                const alert = yield take(channel)
                yield put(addRecentAlert(alert))
                yield put(addAlertCount())
            }
        } catch(e) {
            console.log(e, "error")
        } finally {
            closeChannel(channel)
        }
    })
}

export function* requestAllAlertsDone() {
    yield takeEvery(REQUEST_ALL_ALERTS_DONE, function* (action) {
        try {
            yield put(requestAlertsLoading(true))
            const response = yield call(TowncastService.getAllAlertsDone, action.siteid, action.start, action.end)
            yield put(requestAllAlertsDoneSuccess(response.data))
        } catch (err) {
            yield put(requestAllAlertsDoneFailed(err))
        }
    })
}

export default function* rootSaga() {
    yield all([
        fork(requestAlerts),
        fork(requestAlertsModify),
        fork(waitRecentAlert),
        fork(requestAllAlertsDone)
    ])
}